<template>
  <div class="new-product">
    <div class="container product-box">
      <div class="tit-box">
        <div class="tit">{{$t('GA.newPro')}}</div>
        <div class="right-box">
          <div class="more" @click="moreClick">
            {{$hs("查看更多","View More",'')}}
            <i class="el-icon-arrow-right"></i>
          </div>
        </div>
      </div>
      <div class="new-product-info">
        <div class="row" v-for="(item, ind) in newProducts" :key="ind">
          <everyProduct :productData="item"></everyProduct>
        </div>
        <div style="width: 100%;" v-if="newProducts.length <= 0">
          <el-empty></el-empty>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { addCartsApi, deletCartsApi } from '@/api/cart'
import { getMoothList, randomProducts } from '@/api/product'
import { queryPage } from '@/api/product'
import everyProduct from '@/components/productBox/everyProduct.vue' //单个产品组件
import { mapState, mapActions, mapGetters } from 'vuex'
import transformMark from '@/utils/water'
export default {
  name: 'newProduct',
  components: {
    everyProduct
  },
  props: {
    datas: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      btnplay: true, //默认播放

      isDom: false,
      active: '0',
      times: '',
      daytimeArr: [],
      newProducts: [],
      queryParam: {
        client_Nu: '',
        num: 18,
        category: 1,
        startTime: null
      },
      queryParampnewproduct: {
        pageNo: 1,
        pageSize: 18,
        sortField: '',
        sortOrder: '',
        cl_Nu: '',
        faNos: [],
        coNus: [],
        isAnd: false,
        keywords: '',
        conditionals: [],
        startTime: null
      },
    }
  },
  computed: {
    // 用户信息
    ...mapState('user', ['userInfo']),
    // 语言
    ...mapState('operate', ['language']),
    ...mapGetters('operate', {
      gettingCart: 'getting_cart',
      getEnquiry: 'get_enquiry'
    }),

    // 标记购物车图标
    markCart() {
      return coNu => {
        // 购物车列表为空，直接返回标记
        return this.gettingCart.findIndex(item => item.co_Nu === coNu) > -1
      }
    }
  },
  async created() {
    // await this.getDate()
    await this.queryData()
    this.startAnimation
  },

  methods: {
    ...mapActions('operate', {
      addCart: 'add_cart',
      deleteCart: 'delete_cart',
      setEnquiry: 'set_enquiry'
    }),
    startAnimation() {
      this.$nextTick(() => {
        if (this.$refs.wrapper) {
          this.$refs.wrapper.style.animationPlayState = 'running'
        }
      })
    },
    moreClick() {
      this.$router.push({
        path: '/newPro'
      })
    },
    stopAnimation() {
      this.$nextTick(() => {
        if (this.$refs.wrapper) {
          this.$refs.wrapper.style.animationPlayState = 'paused'
        }
      })
    },

    async getDate() {
      // await getMoothList({ num: 6 }).then(res => {
      //   if (res.success) {
      //     this.daytimeArr = res.data
      //     this.queryParam.startTime = res.data[0]
      //   }
      // })
    },

    // 换一批
    anotherBatch() {
      this.queryData()
    },

    queryData() {
      const loading = this.$loading({
        lock: true,
        text: this.$t('GA.loading'),
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      this.queryParampnewproduct.client_Nu = this.userInfo.client_Nu || ''
      queryPage(this.queryParampnewproduct)
        .then(res => {
          if (res.success) {
            let arr = []
            let arrTow = []
            this.newProducts = res.data.rows.map(item => {
              const ind = this.getEnquiry[0].list.findIndex(
                it => it.co_Nu === item.co_Nu
              )
              if (ind > -1) {
                return { ...item, _num_: true }
              }
              return { ...item, _num_: false }
            })

            this.newProducts.forEach(item => {
              transformMark(item.imgUrl + '?imageMogr2/thumbnail/800x').then(
                result => {
                  item.imgUrl = result
                }
              )
              // if (arr.length == 2) {
              //   arrTow.push(arr)
              //   arr = []
              // }
              // if (arr.length != 2) {
              arr.push(item)
              // }
            })
            // if (arr.length == 1) {
            //   arrTow.push(arr)
            // }
            this.newProducts = arr
          } else {
            this.$message.error(res.message)
          }
        })
        .catch(err => {
          this.$message.error(err.message)
        })
        .finally(() => {
          loading.close()
        })
    },

    onSendInquiry(items, arr, ind) {
      arr.forEach(it => {
        if (it.co_Nu === items.co_Nu) {
          it._num_ = !it._num_
          this.setEnquiry(items)
          this.isDom = true
          this.$nextTick(() => {
            this.isDom = false
          })
        }
      })
    },
    tabChange(item, index) {
      console.log('object :>> ', item, index)
      this.active = String(index)
      this.queryParam.startTime = item
      this.queryData()
    },
    // 添加到购物车
    handleToCart(item) {
      // 必须登陆后才能添加购物车
      if (this.userInfo === '') {
        this.$message({
          message: this.$t('noLogin'),
          type: 'warning'
        })
        return
      }
      if (this.markCart(item.co_Nu)) {
        deletCartsApi({
          userId: this.userInfo.id,
          coNus: [item.co_Nu]
        }).then(res => {
          if (res.success) {
            this.deleteCart(item.co_Nu)
          }
        })
      } else {
        addCartsApi({
          client_Nu: this.userInfo.client_Nu,
          userId: this.userInfo.id,
          co_Nu: item.co_Nu,
          number: 1
        }).then(res => {
          if (res.success) {
            this.addCart({
              client_Nu: this.userInfo.client_Nu,
              userId: this.userInfo.id,
              co_Nu: item.co_Nu,
              fa_No: item.fa_No,
              imgUrl: item.imgUrl,
              in_En: item.in_En,
              number: 1,
              ou_Lo: item.ou_Lo,
              pr_En_Na: item.pr_En_Na,
              pr_Na: item.pr_Na,
              price: item.price,
              bulk_Stere: item.bulk_Stere
            })
          }
        })
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.new-product-info {
  display: flex;
  flex-wrap: wrap;
  width: 1200px;
  color: #828282;
  padding: 20px 0;
  box-sizing: border-box;
  .row {
    width: 180px;
    height: 280px;
    margin-right: 24px;
    margin-bottom: 24px;
    box-sizing: border-box;
    overflow: hidden;
    // box-shadow: 0px 0 5px 1px #e5e5e5;
    &:nth-child(6n) {
      margin-right: 0px;
    }
  }
}
// 66666666666
.product-box {
  .tit-box {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: 40px;
    background: #ff0000;
    padding: 0 30px;
    color: #ffffff;
    .tit {
      flex: 1;
      height: 54px;
      font-size: 16px;
      font-weight: 700;
      text-align: left;

      line-height: 54px;
    }

    .right-box .more {
      cursor: pointer;
      &:hover {
        color: #ffdcdc;
      }
    }
  }
}

.price-box {
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: #f2410f;

  .price {
    font-size: 16px;

    span {
      font-size: 16px;
    }
  }
  .el-icon-shopping-cart-2 {
    font-size: 20px;
    font-weight: bold;
    cursor: pointer;
  }
}

.mfrs-btn {
  height: 36px;
  background: #ffffff;
  border: 1px solid #dfdfdf;
  border-radius: 4px;
  margin: 10px 0 0 0;
  text-align: center;
  line-height: 34px;
  font-size: 14px;
  box-sizing: border-box;
  cursor: pointer;
  &:hover {
    background-color: #f4400f;
    color: #fff;
    span {
      margin: 0 0 0 6px;
      color: #fff;
    }
  }
  span {
    margin: 0 0 0 6px;
    color: #222222;
  }
}

.new-product {
  width: 100%;
  background-color: #f5f5f5;
}
</style>